import { lazy, type FC } from 'react';
import { useParams } from 'react-router';
import type { Uuid } from 'src/apis/api-utilities';
import { useHydrogenFcfsRootLink } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-root';
import { useHydrogenShipperBookingDetails } from 'src/apis/hydrogen-fcfs/use-hydrogen-shipper-booking-details';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const HydrogenShipperBookingDetails: FC = () => {
  const params = useParams<{ bookingProcessId: Uuid }>();
  const url = useHydrogenFcfsRootLink('bookingDetailsShipper');
  const bookingDetailsRequest = useHydrogenShipperBookingDetails({
    url,
    bookingProcessId: params.bookingProcessId,
  });

  if (!bookingDetailsRequest.response) return <PageSpinner />;

  return <Page bookingDetailsRequest={bookingDetailsRequest} />;
};
